import { AgentAttachment, AgentResponseSegment } from '../../utils/agent-client';
import { FeedbackType } from './agent-chat-constants';

export const MessageRole = {
  USER: 'user',
  ASSISTANT: 'assistant'
} as const;

// A file sent with a user message. Only its name and size are kept: the bytes go to the agent once
// and are never stored client-side.
export interface ChatAttachment {
  filename: string;
  size: number;
}

// A file picked in the prompt box, already read. Its bytes are captured when it's picked, so a file
// re-saved or moved before Send can't fail the send.
export type PendingAttachment = ChatAttachment & AgentAttachment;

export interface UserChatMessage {
  id: string;
  role: typeof MessageRole.USER;
  content: string;
  timestamp: number;
  attachment?: ChatAttachment;
}

export interface AssistantChatMessage {
  id: string;
  role: typeof MessageRole.ASSISTANT;
  segments: AgentResponseSegment[];
  timestamp: number;
  // The agent runtime that produced this message (llm_messages.agent). Only set by hosts that route
  // between agents; undefined for legacy rows and single-agent hosts.
  agent?: string;
  // The backend llm_messages.id, needed to submit feedback. Set once a live-streamed
  // response's fire-and-forget /saveLLMMessage resolves; set immediately for messages
  // rehydrated from history, since their client-side `id` already IS the persisted one.
  persistedId?: string;
  // Feedback already recorded on this message in a prior session, restored from
  // llm_messages on hydration so a reopened chat doesn't look unrated.
  persistedFeedback?: FeedbackType | null;
  persistedFeedbackReason?: string | null;
}

export type AgentMessage = UserChatMessage | AssistantChatMessage;

export interface FeedbackSubmission {
  messageId: string;
  feedback: FeedbackType | null;
  reason: string | null;
}
